// extracted by mini-css-extract-plugin
export default {"root":"AlbumsGrid__root--1u29C","album":"AlbumsGrid__album--307Y5"};